// ./components/Home.js
import GainsTicker from '../components/ResultsTicker';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../index.css';
import Plans from './Plans';
import About from './About';
import NavMain from './Navbar';
import FooterNav from './Footer';
import ContactOffcanvas from './ContactOffcanvas';
import Results from './Results';


function Home() {
  

  return (
    
    
    
    <div className="home" id='home'>
      <Row className='p-5'>
      <NavMain />
      </Row>
      
      <Row className='p-3'>
        
          <h1>
            <b>

              FROM AVERAGE TO APEX
            </b>
          </h1>
        
      </Row>
      <Row className='m-2 mb-5'>
          <GainsTicker/> 
      </Row>
      <Row className='justify-content-md-center mb-5 mt-5'>
        <Col>
          <ContactOffcanvas  name={'Start Your Evolution'} buttonVariant={'danger'} buttonSize={'lg'} shadow />
        </Col>
      </Row>
      <div className='infoHome pb-3 m-5'>
        <Row>
          <Col>
            <Row>
              <img src="img/Logo Red.svg" alt="Red Logo" height="95" />
            </Row>
            <Row>
              <h2>Customized Workouts</h2>
            </Row>
            <Row>
              <p>Personalized training plans tailored to your goals</p>
            </Row>
          </Col>
          <Col>
            <Row>
              <img src="img/Logo Red.svg" alt="Red Logo" height="95"/>
            </Row>
            <Row>
              <h2>Nutrition Programs</h2>
            </Row>
            <Row>
              <p>Specialized meal plans based on preferred foods and lifestyle</p>
            </Row>
          </Col>
          <Col >
            <Row>
              <img src="img/Logo Red.svg" alt="Red Logo" height="95"/>
            </Row>
            <Row>
              <h2>Step-by-Step Guidance</h2>
            </Row>
            <Row>
              <p>Professional supervision to keep you motivated and accountable</p>
            </Row>
          </Col>
        </Row>
        
      </div>
      
      <Row id='plans'>
        <Plans />
      </Row>

      <Row id="results">
        <Results />

      </Row>
      <Row id="about" >
        <About />
      </Row>
      
      <Row>
        <FooterNav />
      </Row>
      
    </div>
    
  
  );
}

export default Home;